// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"10":"20a91dc374dea9c8","821":"49bbdc8c654770fb","827":"566cd646a79d0e1f","883":"b489ed8a11f7fbae"}[chunkId] + ".js";
};